/** Copyright 2026 Midas Healthcare Solutions - All Rights Reserved **/
export enum CentralPharmacyPageType {
  TransportBags,
  BlueCheckBags,
}
